Namespace 'Customer.Dashboard'

class Customer.Dashboard.SessionExpirationCounterView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/session_expiration_counter']
  tagName: 'span'

  initialize: (@options = {}) ->
    @model = @options.model
    @listenTo(@model, "change", @_refreshTimer)

  render:()->
    hours = @model.hours
    minutes = @model.minutes
    seconds = @model.seconds
    @$el.html(@template({hours: hours, minutes:minutes, seconds: seconds}))
    @

  _refreshTimer: ->
    @render()

